
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_empresa',
        label: 'Empresa',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        title:{
            model: 'empresa_envio_automatico',
            description: 'ssss'
        },
        info: '',
        clearable: true,
        placeholder:'Todas',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_fdt',
        label: 'Frente de Trabalho',
        option: {
            key: 'id',
            label: 'fdt',
            value: 'id'
        },
        info: '',
        clearable: true,
        placeholder:'Todas',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-custom',
        field: 'id_funcionario',
        label: 'Funcionario',
        option: {
            key: 'id',
            label: 'nome',
            value: 'id'
        },
        info: '',
        clearable: true,
        placeholder:'Todos',
        rules: ['']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'select-tipo',
        field: 'id_tipo_status',
        label: 'Status',
        tipo: 327,
        multiple:true,
        placeholder:'Todos',
        rules: ['']
    },
    // {
    //     class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
    //     type: 'select-custom',
    //     field: 'mostrar',
    //     label: 'Mostrar',
    //     option: {
    //         key: 'id',
    //         label: 'nome',
    //         value: 'id'
    //     },
    //     info: '',
    //     clearable: true,
    //     rules: ['']
    // },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'date-range',
        field: 'data_cadastro',
        label: 'Data de Cadastro',
        info: '',
        clearable: true,
        rules: ['']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/esocial/_form/filtrar.js